module.exports = __webpack_public_path__ + "img/ellipsis.56569a15.svg";